module.exports = __webpack_public_path__ + "static/img/check_unchecked_select.695563bf.svg";